import { createDataGridFilter } from '../create-data-grid-filter';
import {
  createOneOfAsyncFilterModel,
  OneOfAsyncFilterModel,
  oneOfAsyncFilterModelName,
  OneOfAsyncFilterParams,
} from './core';
import { OneOfAsyncFilterComponent } from './one-of-async-filter.component';

export const OneOfAsyncFilterDataGrid = createDataGridFilter<
  OneOfAsyncFilterModel,
  OneOfAsyncFilterParams
>((params) => ({
  modelName: oneOfAsyncFilterModelName,
  modelFactory: createOneOfAsyncFilterModel,
  component: (props) => (
    <OneOfAsyncFilterComponent {...props} filterParams={params} />
  ),
}));

export type OneOfAsyncFilterDataGridComponent = ReturnType<
  typeof OneOfAsyncFilterDataGrid
>;
